import { createTopNLeadsSearchRequestDto } from "app/pages/sales-intelligence/modules/leads-search";
import { getLeadDomainFromRow } from "app/pages/sales-intelligence/modules/leads-search/utils/rows";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { is } from "app/pages/sales-intelligence/utils/type-guards";
import queryClient from "single-spa/react-app/query-client";

import { opportunityListQueryKeyFactory } from "../queryKeyFactory";
import type { FetchTopNLeadsDomainsFnParams } from "../types";

export const fetchTopNLeadsDomains = async <P extends FetchTopNLeadsDomainsFnParams>({
    leadsType,
    domainsCount,
    listParams,
    dto,
}: P): Promise<readonly string[] | undefined> => {
    if (!domainsCount || !leadsType || !dto) {
        return;
    }

    const updatedDto = createTopNLeadsSearchRequestDto(dto, domainsCount);

    const searchResults = await queryClient.fetchQuery({
        queryKey: opportunityListQueryKeyFactory.leadsTableData(listParams.id, leadsType, updatedDto),
        queryFn: ({ signal }) =>
            salesApiService.opportunityListPage.fetchLeadsSearchResults(
                { listParams, dto: updatedDto, leadsType: leadsType },
                {
                    cancellation: signal,
                },
            ),
    });

    if (is.undefined(searchResults)) {
        return [];
    }

    return searchResults.rows.map(getLeadDomainFromRow);
};
